import {
  screensFlow as routes,
  screens as routeNames,
} from '@/constants/form-find-tickets';

class AutoFlowService {
  #autoFlow;
  #routes;
  #initial;

  constructor() {
    this.#autoFlow = true;
    this.#routes = routes;
    this.#initial = routes[0];
  }

  init = (routeName) => {
    if (routes.includes(routeName)) {
      this.#initial = routeName;
      this.#routes = [routeName].concat(
        routes.filter((item) => item !== routeName),
      );
    } else {
      console.warn(`[AutoFlow] init route '${routeName}' no found`);
    }
  };

  getState = () => {
    return this.#autoFlow;
  };

  setState = (value) => {
    this.#autoFlow = !!value;
  };

  next = (routeName = '') => {
    const index = this.getIndex(routeName);

    return this.#autoFlow ? this.#routes[index + 1] : routeNames.SEARCH;
  };

  prev = (routeName = '') => {
    const index = this.getIndex(routeName);

    return this.#autoFlow ? this.#routes[index - 1] : routeNames.SEARCH;
  };

  getIndex = (routeName) => {
    const index = this.#routes.indexOf(routeName);

    if (index < 0) {
      console.warn(`[AutoFlow] getIndex route '${routeName}' no found`);
    }

    return index;
  };

  isStart = (routeName) => {
    return routeName === this.#initial;
  };

  isFinish = (routeName) => {
    const index = this.getIndex(routeName);

    return index === routes.length - 1;
  };
}

export const AutoFlow = new AutoFlowService();
